import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomersService } from 'src/app/services/customer/customer.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user/user.service';
import { CustomerdosService } from 'src/app/services/customerdos/customerdos.service';
import { MasterdosService } from 'src/app/services/masterdos/masterdos.service';
import { TaskService } from 'src/app/services/task/task.service';
import { TourService } from 'src/app/services/tour/tour.service';
import { SettingService } from 'src/app/services/setting/setting.service';
import { PhleboService } from 'src/app/services/phlebo/phlebo.service';
import { RunnerService } from 'src/app/services/runner/runner.service';
import { PlanService } from 'src/app/services/plan/plan.service';

import { LablocationService } from 'src/app/services/lablocation/lablocation.service';
import { OrderService } from 'src/app/services/order/order.service';
import { SalesService } from 'src/app/services/sales/sales.service';
import { LeaveService } from 'src/app/services/leave/leave.service';
import { CouponService } from 'src/app/services/coupon/coupon.service';
import { EnduserService } from 'src/app/services/enduser/enduser.service';
import { BannerService } from 'src/app/services/banner/banner.service';
import { Router } from '@angular/router';
import { AbstractControl,FormControl, FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { LocationService } from 'src/app/services/location/location.service';
import { PayableReportService } from 'src/app/services/payable-report/payable-report.service';
import { ReceivableReportService } from 'src/app/services/receivable-report/receivable-report.service';
@Component({
    selector: 'app-deleteModal',
    templateUrl: './deleteModal.component.html',
    styleUrls: ['./deleteModal.component.scss']
})
export class deleteModalComponent implements OnInit {
    @Input() props: any;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();

    public title: string;
    public subTitle: string;
    public cancelAppointmentReason: any = [];
    public type: string;
    public data: any;
    public encryptedId: any;
    public categoryName: string;
    public status: boolean;
    public approved: any;
    public page: any = 1;
    public dosStatus: any;
    public dosId: any;
    public report_id:any;
    public areaStatus: any;
    public areaId: any;
    public isBtnLoaded = false;
    public screenName: any;
    public phleboId: any;
    public phleboStatus: any;
  public  visitId:any;
    isLoadedTable: boolean;
    slotlist: any;
    phleboList: any;
    submittoopsForm: FormGroup;
    phlebotype: any=true;
    phleboDropDown: any;
    form: FormGroup;
    totalSlot: any;
    items: any;
    submitBtnLoader = false;

    constructor(
        private ngbModal: NgbActiveModal,
        private toastr: ToastrService,
        private enduserService: EnduserService,
        private tourService: TourService,
        private couponService: CouponService,
        private customerService: CustomersService,
        private taskService: TaskService,
        private lablocationService: LablocationService,
        private userService: UserService,
        private runnerService: RunnerService,
        private customerdosService: CustomerdosService,
        private masterdosService: MasterdosService,
        private OrderService: OrderService,
        private settingService: SettingService,
        private bannerService: BannerService,
        private phleboService: PhleboService,
        private planService: PlanService,
        private router: Router,
        private formBuilder: FormBuilder,
        private invoiceService : InvoiceService,
        private SalesService : SalesService,
        private leaveService : LeaveService,
        private locationService: LocationService,
        private payableReportService: PayableReportService,
        private receivableReportService:ReceivableReportService,

    ) { }

    ngOnInit(): void {
        this.submitBtnLoader = false;

        this.setDialogProps(this.props);
        if(this.type=='submitedToOPS')
        {
            this.submittoopsForm = this.formBuilder.group({
                phlebo:  ['',Validators.required],
                phlebotype: ['without_phlebo'],


            });


            this.OrderService.getAllPhleboList(this.data).subscribe(
                (res: any) => {
                    this.phleboDropDown = res.data;

                },
                (err: any) => {
                    this.onClose();
                    this.toastr.error(`${err.statusText}`);

                },
                ()=>{
                    this.isLoadedTable = false;
                }
            );
        }
        if(this.type=='available_slot')
        {
            this.submitBtnLoader = false;

            this.form = this.formBuilder.group({
                customer_id: [''],
                id: [''],

                city_id: [''],
                state_id: [''],
                areacode_id: [''],
                slot: [''],
                special_slot: [''],

                items: this.formBuilder.array([])



            });
            this.customerService.get_customers_contract_slot(this.data.customer_id,this.data.areacode_id).subscribe((data) => {

              //  this.customerPinCodeLists = data.data.customer_contracted_pin_codes
                this.form.get('id').setValue(data.data.id),
                this.form.get('customer_id').setValue(data.data.customer_id);
                this.form.get('city_id').setValue(data.data.city_id);
                this.form.get('state_id').setValue(data.data.state_id);
                this.form.get('areacode_id').setValue(data.data.areacode_id);
                this.form.get('slot').setValue(data.data.slot);
                this.form.get('special_slot').setValue(data.data.special_slot);



            })

            this.customerService.getAllAvailableslot(this.data.customer_id,this.data.areacode_id).subscribe(
                (res: any) => {
                    this.slotlist = res.data;
                    this.items = this.form.get('items') as FormArray;
            this.items.clear();



            for (let index = 0; index < res.data.length; index++) {
                if (res.data[index].slot != '') {
                   this.items.push(this.createItem(res.data[index].id,res.data[index].slot,res.data[index].available_slot));

                }
            }


         this.totalSlot=res.data.length;
                },
                (err: any) => {
                    this.onClose();
                    this.toastr.error(`${err.statusText}`);

                },
                ()=>{
                    this.isLoadedTable = false;
                }
            );
        }
    }
    createItem(id:any,slot:any,number:any): FormGroup {
        return this.formBuilder.group({
        slot,
        id,
        number: [number]
        });
    }

    setDialogProps(dialogdata: any) {
        this.title = dialogdata.title;
        this.subTitle = dialogdata.subTitle;
        this.type = dialogdata.type;
        this.data = dialogdata.data;
        this.page = dialogdata.page;
        this.dosId = dialogdata.dosId;
        this.report_id = this.data.id;
        this.areaId = dialogdata.areaId;
        this.areaStatus = dialogdata.areaStatus;
        this.dosStatus = dialogdata.dosStatus;
        this.screenName = dialogdata.screenName;
    }

    get f(): { [key: string]: AbstractControl } {
        return this.submittoopsForm.controls;
    }
    submitTypeChange() {
        this.phlebotype = this.f.phlebotype.value
        if(this.phlebotype=='without_phlebo')
        {
            this.submittoopsForm.value.phlebo='';

        }

    }

    onCloseNext()
    {
    this.passEntry.next(this.page);
    this.ngbModal.close();
    }
    onSubmit()
    {
        this.submitBtnLoader=true;
        this.customerService.submitToSlot( this.form.value).subscribe(
            (res: any) => {
                if (res && res.success) {
                    this.toastr.success(`${res.message}`);
                    this.onClose();
                } else {
                    if (res.message) {
                        this.toastr.error(`${res.message}`);
                    } else {
                        this.toastr.error(`Status change failed`);
                    }
                }


                this.submitBtnLoader=false;

                this.isBtnLoaded = false;
            },
            (err: any) => {
                this.onClose();
                this.toastr.error(`${err.statusText}`);

            }
        );

    }

    onDelete() {


        switch (this.type) {
            case 'deleteBankDeposit':
                this.isBtnLoaded = true;
                this.OrderService.deleteBankDeposit(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    }
                );
                break;
			case 'submitedToOPS':

                this.isBtnLoaded = true;
                this.OrderService.submitToOps(  this.data,this.submittoopsForm.value.phlebo).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Status change failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    }
                );
                break;






                case 'submitedToOPSGroup':
                this.isBtnLoaded = true;
                this.OrderService.submitToOpsGroup(  this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Status change failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    }
                );
                break;

                case 'createdInvoice':
                this.isBtnLoaded = true;
                this.OrderService.createInvoices(  this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Status change failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    }
                );
                break;

                case 'submitedToOPSByView':
                this.isBtnLoaded = true;
                this.OrderService.submitToOps(  this.data,this.submittoopsForm.value.phlebo).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Status change failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    }
                );
                break;
            case 'updateStatusDos':
                this.isBtnLoaded = true;
                this.customerdosService.updateStatus(this.data, this.dosStatus).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Status change failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    }
                );
                break;

            case 'updateStatusPhlebo':
                this.isBtnLoaded = true;
                this.phleboService.updateStatus(this.data.id, this.data.status).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success('Phlebo updated successfully');
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Status change failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    }
                );
                break;


            case 'updateStatusArea':
                this.isBtnLoaded = true;
                this.settingService.updateAreaStatus(this.areaId, this.areaStatus).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Status change failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    }
                );
                break;
            case 'deleteDos':
                this.isBtnLoaded = true;
                this.customerdosService.deleteDos(this.dosId).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Dos deleted successfully`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    }
                );
                break;
                case 'deletemasterDos':
                    this.isBtnLoaded = true;
                    this.masterdosService.deleteDos(this.dosId).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Dos deleted successfully`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);

                        }
                    );
                    break;

                    case 'cancelAppointment':
                    this.isBtnLoaded = true;
                    const status = {status:'cancelled',cancel_reasons_id:this.cancelAppointmentReason};
                    this.SalesService.cancelAppointment(status,this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Customer deleted successfully`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);

                        }
                    );
                    break;

                case 'deleteEnduser':
                    this.isBtnLoaded = true;
                    this.enduserService.deleteEnduser(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Customer deleted successfully`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);

                        }
                    );
                    break;
                    case 'deletephleboPlan':
                        this.isBtnLoaded = true;
                        this.planService.deletephleboPlan(this.data).subscribe(
                            (res: any) => {
                                if (res && res.status) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`Customer deleted successfully`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);

                            }
                        );
                        break;

                    case 'deletePatient':
                        this.isBtnLoaded = true;
                        const id =this.data[0];
                        const user_id = this.data[1];
                        this.OrderService.deletePatient(id,user_id).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`Customer deleted successfully`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);

                            }
                        );
                        break;

                        case 'deleteAddress':
                            this.isBtnLoaded = true;
                            const id1 =this.data[0];
                            const user_id1 = this.data[1];
                            this.OrderService.deleteAddress(id1,user_id1).subscribe(
                                (res: any) => {
                                    if (res && res.success) {
                                        this.toastr.success(`${res.message}`);
                                        this.onClose();
                                    } else {
                                        if (res.message) {
                                            this.toastr.error(`${res.message}`);
                                        } else {
                                            this.toastr.error(`Customer deleted successfully`);
                                        }
                                    }
                                    this.isBtnLoaded = false;
                                },
                                (err: any) => {
                                    this.onClose();
                                    this.toastr.error(`${err.statusText}`);

                                }
                            );
                            break;

                            case 'deleteReport':
                                this.isBtnLoaded = true;
                                this.OrderService.deletereport(this.data.id).subscribe(
                                    (res: any) => {
                                        if (res && res.success) {
                                            this.toastr.success(`${res.message}`);
                                            this.onClose();
                                        } else {
                                            if (res.message) {
                                                this.toastr.error(`${res.message}`);
                                            } else {
                                                this.toastr.error(`Customer deleted successfully`);
                                            }
                                        }
                                        this.isBtnLoaded = false;
                                    },
                                    (err: any) => {
                                        this.onClose();
                                        this.toastr.error(`${err.statusText}`);

                                    }
                                );

                    break;
                    case 'deletePhleboLeave':
                    this.isBtnLoaded = true;
                    this.phleboService.deleteLeave(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Customer deleted successfully`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);

                        }
                    );
                    break;
                    case 'deleteRunnerLeave':
                    this.isBtnLoaded = true;
                    this.leaveService.deleteLeave(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.msg}`);
                                this.onClose();
                            } else {
                                if (res.msg) {
                                    this.toastr.error(`${res.msg}`);
                                } else {
                                    this.toastr.error(`Customer deleted successfully`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);

                        }
                    );
                    break;
                    case 'deletePrescription':
                        this.isBtnLoaded = true;
                        this.enduserService.deletePrescription(this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`Customer deleted successfully`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);

                            }
                        );
                        break;
                case 'deleteCoupon':
                  this.isBtnLoaded = true;
                  this.couponService.deleteCoupon(this.data).subscribe(
                      (res: any) => {
                          if (res && res.success) {
                              this.toastr.success(`${res.message}`);
                              this.onClose();
                          } else {
                              if (res.message) {
                                  this.toastr.error(`${res.message}`);
                              } else {
                                  this.toastr.error(`Dos deleted successfully`);
                              }
                          }
                          this.isBtnLoaded = false;
                      },
                      (err: any) => {
                          this.onClose();
                          this.toastr.error(`${err.statusText}`);

                      }
                  );
                  break;
                  case 'deletebanner':
                    this.isBtnLoaded = true;
                    this.bannerService.deleteBanner(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success('Banner successful deleted');
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Dos deleted successful`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);

                        }
                    );
                    break;
            case 'deleteCustomer':
                this.isBtnLoaded = true;
                this.customerService.deleteCustomer(this.data.id, 'customer').subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
  // ------------Task-ondemand-----------------------
                case 'deleteLablocation':
                this.isBtnLoaded = true;
                this.lablocationService.deleteLablocation(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );


                break;
                case 'makeStartTaskLocaion':
            this.isBtnLoaded = true;
            this.taskService.makeStartPoint(this.data).subscribe(
                (res: any) => {
                    if (res && res.success) {
                        this.toastr.success(`${res.message}`);
                        this.onClose();
                    } else {
                        if (res.message) {
                            this.toastr.error(`${res.message}`);
                        } else {
                            this.toastr.error(`Delete failed`);
                        }
                    }
                    this.isBtnLoaded = false;
                },
                (err: any) => {
                    this.onClose();
                    this.toastr.error(`${err.statusText}`);
                }
            );
            break;

            case 'makeEndTaskLocaion':
                this.isBtnLoaded = true;
                this.taskService.makeEndPoint(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;

                  case 'copyTour':
                                            this.isBtnLoaded = true;
                                            this.tourService.copyTour(this.data).subscribe(
                                                (res: any) => {
                                                    if (res && res.success) {
                                                        this.toastr.success(`${res.message}`);
                                                        this.onClose();
                                                    } else {
                                                        if (res.message) {
                                                            this.toastr.error(`${res.message}`);
                                                        } else {
                                                            this.toastr.error(`Delete failed`);
                                                        }
                                                    }
                                                    this.isBtnLoaded = false;
                                                },
                                                (err: any) => {
                                                    this.onClose();
                                                    this.toastr.error(`${err.statusText}`);
                                                }
                                            );
                                            break;

                case 'deleteTask':
                    this.isBtnLoaded = true;
                    this.taskService.deleteTask(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Delete failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        }
                    );
                    break;
                    case 'MarkCollectedTask':
                        this.isBtnLoaded = true;
                        this.taskService.markCollected(this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`Delete failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );
                        break;


                        case 'deleteTourLocaion':
                            this.isBtnLoaded = true;
                            this.tourService.deleteTourLocaion(this.data).subscribe(
                                (res: any) => {
                                    if (res && res.success) {
                                        this.toastr.success(`${res.message}`);
                                        this.onClose();
                                    } else {
                                        if (res.message) {
                                            this.toastr.error(`${res.message}`);
                                        } else {
                                            this.toastr.error(`Delete failed`);
                                        }
                                    }
                                    this.isBtnLoaded = false;
                                },
                                (err: any) => {
                                    this.onClose();
                                    this.toastr.error(`${err.statusText}`);
                                }
                            );
                            break;

                    case 'deletetaskLocation':
                        this.isBtnLoaded = true;
                        this.taskService.deleteTaskLocaion(this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`Delete failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );
                        break;

                    case 'deleteTour':
                      this.isBtnLoaded = true;
                      this.tourService.deleteTour(this.data).subscribe(
                          (res: any) => {
                              if (res && res.success) {
                                  this.toastr.success(`${res.message}`);
                                  this.onClose();
                              } else {
                                  if (res.message) {
                                      this.toastr.error(`${res.message}`);
                                  } else {
                                      this.toastr.error(`Delete failed`);
                                  }
                              }
                              this.isBtnLoaded = false;
                          },
                          (err: any) => {
                              this.onClose();
                              this.toastr.error(`${err.statusText}`);
                          }
                      );
                      break;

                      case 'deleteLocation':
                        this.isBtnLoaded = true;
                        this.locationService.deleteLocation(this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                        this.onClose();
                                    } else {
                                        this.toastr.error(`Delete failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );
                        break;
                        case 'deleteProvider':
                        this.isBtnLoaded = true;

                        this.OrderService.deleteProvider(this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                        this.onClose();
                                    } else {
                                        this.toastr.error(`Delete failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );
                        break;
                        // Lab
                         case 'deleteLab':
                        this.isBtnLoaded = true;
                        this.settingService.deleteLab(this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                        this.onClose();
                                    } else {
                                        this.toastr.error(`Delete failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );
                        break;
                        // Delete Device
                         case 'deleteDevice':
                        this.isBtnLoaded = true;
                        this.settingService.deleteDevice(this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.error) {
                                        this.toastr.error(`${res.error}`);
                                        this.onClose();
                                    } else {
                                        this.toastr.error(`Delete failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );
                        break;
                         // Delete Device
                        case 'deleteDeviceInventory':
                        this.isBtnLoaded = true;
                        this.settingService.deleteDeviceInventory(this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.error) {
                                        this.toastr.error(`${res.error}`);
                                        this.onClose();
                                    } else {
                                        this.toastr.error(`Delete failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );
                        break;
                        // case 'updateLabStatus':
                        // this.isBtnLoaded = true;
                        // this.settingService.updateLabStatus(this.areaId, this.areaStatus).subscribe(
                        //     (res: any) => {
                        //         if (res && res.success) {
                        //             this.toastr.success(`${res.message}`);
                        //             this.onClose();
                        //         } else {
                        //             if (res.message) {
                        //                 this.toastr.error(`${res.message}`);
                        //             } else {
                        //                 this.toastr.error(`Status change failed`);
                        //             }
                        //         }
                        //         this.isBtnLoaded = false;
                        //     },
                        //     (err: any) => {
                        //         this.onClose();
                        //         this.toastr.error(`${err.statusText}`);

                        //     }
                        // );
                        // break;
                      case 'makeStartTourLocaion':
                        this.isBtnLoaded = true;
                        this.tourService.makeStartPoint(this.data).subscribe(
                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`Delete failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            }
                        );
                        break;

                        case 'makeEndTourLocaion':
                            this.isBtnLoaded = true;
                            this.tourService.makeEndPoint(this.data).subscribe(
                                (res: any) => {
                                    if (res && res.success) {
                                        this.toastr.success(`${res.message}`);
                                        this.onClose();
                                    } else {
                                        if (res.message) {
                                            this.toastr.error(`${res.message}`);
                                        } else {
                                            this.toastr.error(`Delete failed`);
                                        }
                                    }
                                    this.isBtnLoaded = false;
                                },
                                (err: any) => {
                                    this.onClose();
                                    this.toastr.error(`${err.statusText}`);
                                }
                            );
                            break;

                case 'deleteRunner':
                  this.isBtnLoaded = true;
                  this.runnerService.deleteRunner(this.data).subscribe(
                      (res: any) => {
                          if (res && res.success) {
                              this.toastr.success(`${res.msg}`);
                              this.onClose();
                          } else {
                              if (res.message) {
                                  this.toastr.error(`${res.msg}`);
                              } else {
                                  this.toastr.error(`Delete failed`);
                              }
                          }
                          this.isBtnLoaded = false;
                      },
                      (err: any) => {
                          this.onClose();
                          this.toastr.error(`${err.statusText}`);
                      }
                  );
                  break;

            case 'deleteArea':
                this.isBtnLoaded = true;
                this.settingService.deleteAreaCode(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;

            case 'deleteCity':
                this.isBtnLoaded = true;
                this.settingService.deleteCity(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'deleteLab Location':
                this.isBtnLoaded = true;
                this.customerService.deleteCustomer(this.data.id, 'lab_location').subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'deleteArea Code':
                this.isBtnLoaded = true;
                this.customerService.deleteCustomer(this.data.id, 'area_code').subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'deletePincode':
                this.isBtnLoaded = true;
                this.customerService.deleteCustomer(this.data.id, 'pincode').subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'deleteDOS':
                this.isBtnLoaded = true;
                this.customerService.deleteCustomer(this.data.id, 'dos').subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'deletePrice':
                this.isBtnLoaded = true;
                this.customerService.deleteCustomer(this.data.id, 'price').subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'deleteUser':
                this.isBtnLoaded = true;
                this.userService.deleteUser(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Delete failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'deactivateCustomer':
                this.isBtnLoaded = true;
                this.customerService.statusUpdateCustomer(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Update failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'deleteMasterdos':
                this.isBtnLoaded = true;
                this.settingService.deleteMasterDos(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Update failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'deletePincodeData':
                this.isBtnLoaded = true;
                this.settingService.deletePincode(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Update failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);


                    }
                );
                break;
                case 'deleteRole':
                this.isBtnLoaded = true;
                this.settingService.deleteRole(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Update failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
                case 'deleteCancelReason':
                this.isBtnLoaded = true;
                this.settingService.deleteCancelReason(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Update failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
                case 'deleteRescheduleReason':
                    this.isBtnLoaded = true;
                    this.settingService.deleteRescheduleReason(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Update failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        }
                    );
                    break;
            case 'deletePhleboData':
                this.isBtnLoaded = true;
                this.phleboService.deletePhlebo(this.data).subscribe(
                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success('Phlebo deleted successfully');
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Update failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    }
                );
                break;
            case 'orderDeleteLocas':
                this.isBtnLoaded = true;
                this.OrderService.orderDeleteLocas(this.data.id).subscribe(

                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Update failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    },()=>{
                        this.onClose();

                    }
                );
                break;
                case 'orderDelete':
                    this.isBtnLoaded = true;
                    this.OrderService.orderDelete(this.data.id, this.screenName).subscribe(

                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Update failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        },()=>{
                            this.onClose();

                        }
                    );
                    break;
                    case 'deleteblockdata':
                    this.isBtnLoaded = true;
                    this.settingService.customerblockDelete(this.data).subscribe(

                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Delete failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        },()=>{
                            this.onClose();

                        }
                    );
                    break;
                case 'cancelOrder':
                this.isBtnLoaded = true;
                this.OrderService.cancelOrder(this.data.id).subscribe(

                    (res: any) => {
                        if (res && res.success) {
                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {
                            if (res.message) {
                                this.router.navigateByUrl('orders');

                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Update failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    },()=>{
                        this.onClose();

                    }
                );
                break;
                case 'deleteTeams':
                this.isBtnLoaded = true;
                this.SalesService.deleteTeams(this.data).subscribe(

                    (res: any) => {
                        if (res && res.success) {
                            this.router.navigateByUrl('sales/team');

                            this.toastr.success(`${res.message}`);
                            this.onClose();
                        } else {

                            if (res.message) {

                                this.toastr.error(`${res.message}`);
                            } else {
                                this.toastr.error(`Update failed`);
                            }
                        }
                        this.isBtnLoaded = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);
                    },()=>{
                        this.onClose();

                    }
                );
                break;
                case 'deleteSelsReps':
                    this.isBtnLoaded = true;

                    this.SalesService.deleteSalse(this.data).subscribe(

                        (res: any) => {
                            if (res && res.success) {

                                this.router.navigateByUrl('sales/sales-reps');

                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {

                                if (res.message) {

                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Update failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);

                        },()=>{
                            this.onClose();

                        }
                    );
                break;

                case 'rescheduleOrder':
                    this.isBtnLoaded = true;

                    this.OrderService.rescheduleOrder(this.data.id).subscribe(

                        (res: any) => {
                            if (res && res.success) {

                                this.router.navigateByUrl('orders/edit/'+res.data.order_id+'/'+res.data.visit_id);

                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {

                                if (res.message) {

                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Update failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);

                        },()=>{
                            this.onClose();

                        }
                    );
                    break;

                // case 'upSellOrder':
                //     this.isBtnLoaded = true;
                //
                //     this.OrderService.upSellOrder(this.data.id).subscribe(

                //         (res: any) => {
                //             if (res && res.success) {
                //
                //                 this.router.navigateByUrl('upsell-edit/'+res.data.order_id+'/'+res.data.visit_id);

                //                 this.toastr.success(`${res.message}`);
                //                 this.onClose();
                //             } else {

                //                 if (res.message) {

                //                     this.toastr.error(`${res.message}`);
                //                 } else {
                //                     this.toastr.error(`Update failed`);
                //                 }
                //             }
                //             this.isBtnLoaded = false;
                //         },
                //         (err: any) => {
                //             this.onClose();
                //             this.toastr.error(`${err.statusText}`);
                //
                //         },()=>{
                //             this.onClose();

                //         }
                //     );
                //     break;


                case 'deleteInvoice':
                    this.isBtnLoaded = true;
                    this.invoiceService.deleteInvoice(this.data.id).subscribe(

                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Update failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        },()=>{
                            this.onClose();

                        }
                    );
                    break;
                    case 'deletePartner':
                        this.isBtnLoaded = true;
                        this.settingService.deletePartner(this.data).subscribe(

                            (res: any) => {
                                if (res && res.success) {
                                    this.toastr.success(`${res.message}`);
                                    this.onClose();
                                } else {
                                    if (res.message) {
                                        this.toastr.error(`${res.message}`);
                                    } else {
                                        this.toastr.error(`Update failed`);
                                    }
                                }
                                this.isBtnLoaded = false;
                            },
                            (err: any) => {
                                this.onClose();
                                this.toastr.error(`${err.statusText}`);
                            },()=>{
                                this.onClose();

                            }
                        );
                        break;

                    case 'publishInvoice':
                    this.isBtnLoaded = true;
                    this.invoiceService.publishInvoice(this.data.id).subscribe(

                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success(`${res.message}`);
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Update failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        },()=>{
                            this.onClose();

                        }
                    );
                    break;
                    case 'deleteBatchData':
                    this.isBtnLoaded = true;
                    this.payableReportService.deleteBatch(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success('Batch deleted successfully');
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Delete failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        }
                    );
                    break;
                    case 'paidBatchData':
                    this.isBtnLoaded = true;
                    this.payableReportService.paidBatch(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success('Amount paid successfully');
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Update failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        }
                    );
                    break;
                    case 'paidInvoiceData':
                    this.isBtnLoaded = true;
                    this.receivableReportService.paidInvoice(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success('Mark as paid successfully');
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Update failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        }
                    );
                    break;
                    case 'deleteInvoiceData':
                    this.isBtnLoaded = true;
                    this.receivableReportService.deleteInvoice(this.data).subscribe(
                        (res: any) => {
                            if (res && res.success) {
                                this.toastr.success('Invoice deleted successfully');
                                this.onClose();
                            } else {
                                if (res.message) {
                                    this.toastr.error(`${res.message}`);
                                } else {
                                    this.toastr.error(`Delete failed`);
                                }
                            }
                            this.isBtnLoaded = false;
                        },
                        (err: any) => {
                            this.onClose();
                            this.toastr.error(`${err.statusText}`);
                        }
                    );
                    break;




        }
    }

    onClose() {
        this.passEntry.next(this.page);
        this.ngbModal.close();
    }
}
